import { documentConstants } from "../../constants";
import { documentService } from "../../../services/api.documents";
import { notify } from "reapop";

export const recordingActions = {
  getAll,
  getById,
  create,
  update,
  archive,
  // слово delete зарезервировано
  delete: _delete
};

function getAll(params) {
  return (dispatch) => {
    dispatch(request());

    documentService.getAllRecordings(params).then(
      (response) => dispatch(success(response)),
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка при получении списка документов на оприходование",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request() {
    return { type: documentConstants.GETALL_REQUEST_RECORDING };
  }
  function success(response) {
    return { type: documentConstants.GETALL_SUCCESS_RECORDING, response };
  }
  function failure(error) {
    return { type: documentConstants.GETALL_FAILURE_RECORDING, error };
  }
}

function getById(id) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.getRecordingById(id).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.GETBYID_REQUEST_RECORDING, id };
  }
  function success(response) {
    return { type: documentConstants.GETBYID_SUCCESS_RECORDING, response };
  }
  function failure(error) {
    return { type: documentConstants.GETBYID_FAILURE_RECORDING, error };
  }
}

function create(params) {
  return (dispatch) => {
    dispatch(request(params));

    documentService.createRecording(params).then(
      (response) => {
        dispatch(success(response.result));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(response) {
    return { type: documentConstants.CREATE_REQUEST_RECORDING, response };
  }
  function success(response) {
    return { type: documentConstants.CREATE_SUCCESS_RECORDING, response };
  }
  function failure(error) {
    return { type: documentConstants.CREATE_FAILURE_RECORDING, error };
  }
}

function update(id, params) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.updateRecording(id, params).then(
      (response) => {
        dispatch(success(response.result));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.UPDATE_REQUEST_RECORDING, id };
  }
  function success(response) {
    return { type: documentConstants.UPDATE_SUCCESS_RECORDING, response };
  }
  function failure(error) {
    return { type: documentConstants.UPDATE_FAILURE_RECORDING, error };
  }
}

function archive(id, type) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.archiveDocument(id, type).then(
      (response) => {
        dispatch(success(id));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.ARCHIVE_REQUEST_RECORDING, id };
  }
  function success(id) {
    return { type: documentConstants.ARCHIVE_SUCCESS_RECORDING, id };
  }
  function failure(error) {
    return { type: documentConstants.ARCHIVE_FAILURE_RECORDING, error };
  }
}
function _delete(id, type) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.deleteDocument(id, type).then(
      (response) => {
        dispatch(success(id));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.DELETE_REQUEST_RECORDING, id };
  }
  function success(id) {
    return { type: documentConstants.DELETE_SUCCESS_RECORDING, id };
  }
  function failure(error) {
    return { type: documentConstants.DELETE_FAILURE_RECORDING, error };
  }
}
